const config = {
  apiUrl: 'https://api-dev.skillcraft.app',
  insiderBuild: true,
  alternativeGameFlow: true,
};

export default config;
